export default {
    cardContainer: {
        width: {
            xs: '140px',
            sm: '200px',
            md: '250px',
            lg: '300px',
        },
        cursor: "pointer",
    }
}